import dayjs from 'dayjs';

/**
 * Initialize or update the qsp variable with the current selected product details
 * and other general account product information.
 * @param {Object} product Current selected product details.
 * @param {Object} cardProducts An object of all the Card products available on the account.
 * The keys are the accountTokens of each Card product.
 */
export const runQualtrics = (product = {}, cardProducts = {}) => {
  let qualtricsProduct = product;

  // add a flag if user is a new user
  // first check if user has an account setup date
  if (qualtricsProduct?.status?.account_setup_date) {
    const accountSetupDate = dayjs(qualtricsProduct.status.account_setup_date);
    const today = dayjs();
    const fourteenDaysAgo = today.subtract(14, 'days');
    const isWithinFourteenDays = accountSetupDate.isAfter(fourteenDaysAgo)
      && accountSetupDate.isBefore(today);

    qualtricsProduct = {
      ...qualtricsProduct,
      status: {
        ...qualtricsProduct.status,
        // add isNewUser to detect if Card member is new with Amex
        isNewUser: accountSetupDate.isSame(fourteenDaysAgo)
          || isWithinFourteenDays
          || accountSetupDate.isSame(today),
      },
    };
  }

  // add a flag that counts the number of basic cards and basic+supp cards the user has
  const totalCardProducts = Object.keys(cardProducts).length;
  const totalBasicCardProducts = Object.values(cardProducts)
    .filter((cardProduct) => cardProduct?.account?.relationship === 'BASIC')
    .length;

  qualtricsProduct = {
    ...qualtricsProduct,
    account: {
      ...qualtricsProduct.account,
      totalCardProducts,
      totalBasicCardProducts,
    },
  };

  window.qsp = qualtricsProduct;
};

/**
 * Reset the qsp variable. Typically used for unmounting the component.
 */
export const resetQualtrics = () => {
  window.qsp = undefined;
};
